<template>
  <div>
    <el-skeleton v-if="isLoading" :rows="5" animated />
    <div v-else-if="anexos && anexos.length > 0" v-for="(anexo, index) in anexos" :key="index">
      <div class="anexo-wrapper">
        <strong>{{ anexo.nome }}</strong>
        <div v-if="!anexo.anexos || anexo.anexos.length === 0" class="sem-anexo-card">
          Nenhum item cadastrado
        </div>
        <div v-else v-for="arquivo in anexo.anexos" class="anexo-card" :key="arquivo.idAnexo">
          <div class="icon file-icon">
            <inline-svg fill="currentColor" height="26" :src="require('@/assets/icons/icon_docs.svg')"/>
          </div>
          <div class="anexo-descricao">
            <strong>{{ arquivo.titulo }}</strong>
            <p v-if="arquivo.descricao">
              {{ arquivo.descricao }}
            </p>
          </div>
          <div class="icon">
            <el-link @click="() => downloadFile(arquivo.idAnexo)" :disabled="downloadingFile">
              <inline-svg fill="currentColor" height="26" :src="require('@/assets/icons/Icon_file_download.svg')"/>
            </el-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <EmptyItems :title="tituloVazioTabAnexos" :message="textoVazioTabAnexos" />
    </div>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
import { detalheAnexo, listaAnexos } from '@/views/31/RegrasDeNegocio31'
import { mapGetters, mapState } from 'vuex'
import EmptyItems from '@/components/emptyItems/EmptyItems.vue'

export default {
  name: 'Anexos',
  components: { InlineSvg, EmptyItems },
  props: {
    idAutorizacao: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      anexos: [],
      isLoading: false,
      downloadingFile: false
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('Login', ['user']),
    parametros () {
      return this.funcionalidade.parametros
    },
    tituloVazioTabAnexos () {
      return this.parametros.textos.tituloVazioTabAnexos
    },
    textoVazioTabAnexos () {
      return this.parametros.textos.textoVazioTabAnexos
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.isLoading = true
      const anexos = await listaAnexos(this.user.chaveUnica, this.idAutorizacao)
      this.isLoading = false
      if (anexos && anexos && anexos.tipoAnexos) {
        this.anexos = anexos.tipoAnexos
      }
    },
    async downloadFile (idAnexo) {
      this.downloadingFile = true
      const anexo = await detalheAnexo(this.user.chaveUnica, idAnexo)
      if (anexo.url) {
        window.open(anexo.url, '_blank')
      } else if (anexo.base64) {
        const byteString = atob(anexo.base64)
        const mimeString = 'application/pdf'
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        const blob = new Blob([ab], { type: mimeString })
        const blobUrl = URL.createObjectURL(blob)
        window.open(blobUrl, '_blank')
      }
      this.downloadingFile = false
    }
  }
}
</script>

<style lang="less" scoped>
  .anexo-wrapper {
    margin-bottom: 10px;
  }

  .anexo-card {
    display: flex;
    align-items: center;
    justify-items: center;
    gap: 10px;
    padding: 10px;
    background-color: var(--cor-primaria-aplicacao-transparent);
    border-radius: 6px;
    margin-top: 10px;

    .anexo-descricao {
      flex-grow: 1;
      overflow: hidden;
      color: #333;
      font-size: 11px;

      strong {
        font-size: 1.1em;
        font-weight: 600;
      }
    }
    p {
      margin: 0;
    }
    .icon svg {
      color: var(--cor-primaria-aplicacao)
    }
    .file-icon {
      background-color: #fff;
      border-radius: 6px;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .sem-anexo-card {
    padding: 10px;
    background-color: #F6F6F6;
    border-radius: 6px;
    margin-top: 10px;
    text-align: center;
    color: #888;
  }
</style>
